import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { Reveal } from "@/components/common/Reveal";
import { AnimatedHeading } from "@/components/common/AnimatedHeading";
import { CtaButton } from "@/components/common/CtaButton";
import { siteConfig } from "@/config/site.config";

/** Large statement conversion section that closes the home page. */
export function ClosingCta() {
  return (
    <Section spacing="loose">
      <Container>
        <div className="relative overflow-hidden rounded-[2rem] border border-border bg-primary px-6 py-16 text-center text-primary-foreground sm:px-12 sm:py-24">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -left-20 top-0 h-72 w-72 rounded-full bg-accent/30 blur-[90px]" />
            <div className="absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-white/10 blur-[90px]" />
            <div className="absolute inset-0 bg-grid-light opacity-[0.35]" />
          </div>

          <div className="relative">
            <Reveal>
              <p className="text-sm font-medium uppercase tracking-[0.16em] text-white/70">
                Let's Discuss Your Next Project
              </p>
            </Reveal>
            <AnimatedHeading
              as="h2"
              trigger="inview"
              lines={["Let's Build Software", "That Moves Your Business Forward."]}
              className="mx-auto mt-5 max-w-2xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
            />
            <Reveal delay={0.15}>
              <p className="mx-auto mt-6 max-w-xl text-lg text-white/80">
                Book a free consultation to discuss your business goals, 
                explore technology options and receive a clear, no-obligation roadmap 
                for delivering a solution that creates measurable business value.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-9 flex justify-center">
                <CtaButton
                  to={siteConfig.primaryCta.path}
                  size="lg"
                  variant="secondary"
                  withArrow
                  magnetic
                  data-testid="home-closing-cta"
                >
                  {siteConfig.primaryCta.label}
                </CtaButton>
              </div>
              <p className="mt-4 text-sm text-white/70">
                No obligation. We'll discuss your requirements and recommend the best approach for your business.
              </p>
            </Reveal>
          </div>
        </div>
      </Container>
    </Section>
  );
}
